import { createContext, useContext, useState, type PropsWithChildren } from "react";

type SidenavContextType = {
  open: boolean;
  toggleDrawer: () => void;
  setOpen: (open: boolean) => void;
};

const SidenavContext = createContext<SidenavContextType | undefined>(undefined);

export function SidenavProvider({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <SidenavContext.Provider value={{ open, toggleDrawer, setOpen }}>
      {children}
    </SidenavContext.Provider>
  );
}

export function useSidenav() {
  const context = useContext(SidenavContext);
  if (!context) {
    throw new Error("useSidenav must be used within a SidenavProvider");
  }
  return context;
}
